import React from 'react';
import proptypes from 'prop-types';
const { shape, string } = proptypes;
import { useSpecialBuy } from '../../../context/SpecialBuyProvider';
import {FEATURE_SWITCH_KEYS} from "../../../constants.js";
import {useConfigService} from "@thd-nucleus/experience-context";

export const SeeAll = ({ category }) => {
  const { specialBuyType, specialBuyEndpoint } = useSpecialBuy();
  const isDailyDealsEnabled = useConfigService(FEATURE_SWITCH_KEYS.isDailyDealsEnabled);
  return (
    <div
      className="sui-justify-center sui-align-items-center sui-p-2 sui-text-info"
      // id property is required by analytics
      id={specialBuyType === 'sbotd' ? 'SBOTD' : 'SBOTW'}
      data-testid="see-all-special-buy"
    >
      <a href={`${specialBuyEndpoint}#${category.categoryId}`}>
        See All {category.name} {{
          sbotd: isDailyDealsEnabled ? 'Daily Deals' : 'Special Buy Of The Day',
          pro: 'Pro Special Buy Of The Week',
        }[specialBuyType]}
      </a>
    </div>
  );
};

SeeAll.displayName = 'SeeAll';

SeeAll.propTypes = {
  category: shape({
    name: string.isRequired,
    categoryId: string.isRequired,
  }).isRequired
};
